import React, { ChangeEvent, memo, useCallback, useRef, useState } from 'react'

import Image from '../../image/image'
import Svg from '../../svg/svg'

import * as styles from './styles.module.scss'

const UploadImageButton = ({
   label,
   initialImage,
   isDisabled,
}: UploadImageButtonProps) => {
   const ref = useRef<HTMLInputElement | null>(null)
   const [image, setImage] = useState<string>(initialImage)

   const onClick = useCallback(() => ref?.current?.click(), [ref])

   const handleImageChange = (event: ChangeEvent<HTMLInputElement>) => {
      event.preventDefault()
      const file = event?.target?.files[0] ?? null
      if (file) {
         const imageUrl = URL.createObjectURL(file)
         setImage(imageUrl)
      }
   }

   return (
      <button
         type="button"
         className={styles.button}
         onClick={onClick}
         disabled={isDisabled}
      >
         <input
            type="file"
            accept=".jpg, .png"
            ref={ref}
            onChange={handleImageChange}
         />
         <Image
            url={image}
            alt={label}
            width={83}
            height={83}
            className={styles.image}
         />
         {!isDisabled && (
            <span className={styles.editIcon}>
               <Svg
                  id="edit"
                  width={14}
                  height={14}
                  overrideViewBox="0 0 22 22"
               />
            </span>
         )}
         {label && (
            <label
               className={`${styles.label} ${isDisabled ? '' : styles.pointer}`}
            >
               {label}
            </label>
         )}
      </button>
   )
}

export default memo(UploadImageButton)
